import React from "react";
import i18n from "i18next";
import classNames from "classnames";
import { Link, useLocation } from "react-router-dom";
import { flow } from "lodash";
import { DynamicLinks } from "./dynamicLinks";
import { useCurrentUser } from "frontend/src/utils/hooks";
import SearchIcon from "@mui/icons-material/Search";
import BorderColor from "@mui/icons-material/BorderColor";
import FolderIcon from "@mui/icons-material/Folder";
import DashboardIcon from "@mui/icons-material/Dashboard";
import BubbleChart from "@mui/icons-material/BubbleChart";
import RequestQuoteOutlined from "@mui/icons-material/RequestQuoteOutlined";

function NavSidebarActions(props: {
  onSearchDiscoveryClick: () => void;
  handleClose: () => void;
}) {
  const { onSearchDiscoveryClick, handleClose } = props;
  const user = useCurrentUser();

  const { pathname: currentPage } = useLocation();

  const activeClassName = (pagePath: string) =>
    currentPage === pagePath ? "active" : "";

  const handleItemClick = flow([handleClose]);

  return (
    <div>
      <div
        className={classNames(
          "nav-sidebar__list-item nav-sidebar__list-item--discovery",
          activeClassName("")
        )}
        onClick={onSearchDiscoveryClick}
      >
        <span className="nav-sidebar__list-item-icon icon ">
          <SearchIcon fontSize="large" style={{ margin: "0px" }} />
        </span>
        <span className="nav-sidebar__list-item-text">
          {i18n.t("navigation_sidebar.discovery")}
        </span>
      </div>

      <Link
        to="/notes"
        onClick={handleItemClick}
        className={classNames(
          "nav-sidebar__list-item",
          activeClassName("notes")
        )}
      >
        <span className="nav-sidebar__list-item-icon icon">
          <BorderColor fontSize="large" style={{ margin: "0px" }} />
        </span>

        <span className="nav-sidebar__list-item-text">
          {i18n.t("navigation_sidebar.notes")}
        </span>
      </Link>

      <Link
        to="/documents"
        onClick={handleItemClick}
        className={classNames(
          "nav-sidebar__list-item",
          activeClassName("documents")
        )}
      >
        <span className="nav-sidebar__list-item-icon icon">
          <FolderIcon fontSize="large" style={{ margin: "0px" }} />
        </span>

        <span className="nav-sidebar__list-item-text">
          {i18n.t("navigation_sidebar.documents")}
        </span>
      </Link>

      {user.flags.coreUser && (
        <Link
          to="/notices"
          onClick={handleItemClick}
          className={classNames(
            "nav-sidebar__list-item",
            activeClassName("/notices")
          )}
          data-cy="nav-sidebar-notices"
        >
          <span className="nav-sidebar__list-item-icon icon">
            <RequestQuoteOutlined fontSize="large" style={{ margin: "0px" }} />
          </span>
          <span className="nav-sidebar__list-item-text">
            {i18n.t("navigation_sidebar.notices")}
          </span>
        </Link>
      )}

      {user.flags.isRockCreek && (
        <Link
          to="/internalDashboards"
          onClick={handleItemClick}
          className={classNames(
            "nav-sidebar__list-item nav-sidebar__list-item--people",
            activeClassName("documents")
          )}
        >
          <span className="nav-sidebar__list-item-icon icon">
            <DashboardIcon fontSize="large" style={{ margin: "0px" }} />
          </span>
          <span className="nav-sidebar__list-item-text">
            {i18n.t("navigation_sidebar.internalDashboards")}
          </span>
        </Link>
      )}

      <a
        href="https://storyboard.siriusinnovationlab.com/"
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClose}
        className="nav-sidebar__list-item nav-sidebar__list-item--solutions"
      >
        <span className="nav-sidebar__list-item-icon icon">
          <BubbleChart fontSize="large" style={{ margin: "0px" }} />
        </span>

        <span className="nav-sidebar__list-item-text">
          {i18n.t("navigation_sidebar.storyBoard")}
        </span>
      </a>
      <DynamicLinks handleClose={handleClose} />
    </div>
  );
}

export default NavSidebarActions;
